/** Visual presentation keeps existing action/media nodes and authored order intact.
 * A shared Visual frame overlays the same action rail across all media ratios.
 * The existing inspection viewer always exposes original proportions without cropping. */
export function composeVisualPost(ctx, card, media, post) {
  const frame = ctx.e('div', 'visual-media-frame');
  const actions = card.querySelector('.post-actions');
  frame.append(media);
  if (actions) frame.append(actions);
  card.prepend(frame);
  // Poll choices remain below the framed artwork and its overlaid actions.
  if (post.poll) return;
  card.classList.add('visual-immersive');
  const overlay = ctx.e('div', 'visual-overlay');
  for (const selector of [
    '.post-header',
    '.shared-post-credit',
    '.visual-caption',
    '.read-full-post',
  ]) {
    const node = card.querySelector(selector);
    if (node) overlay.append(node);
  }
  frame.append(overlay);
  const items = media.querySelector('.media-items');
  const nodes = items ? [...items.children] : [media];
  const ratios = [];
  nodes.forEach((node, index) => {
    const item = post.media?.[index];
    const ratio =
      item?.width && item?.height ? item.width / item.height : post.imageAspectRatio || 1.5;
    ratios.push(ratio);
    node.dataset.visualRatio = String(ratio);
    node.dataset.visualAspect = ratio < 0.9 ? 'portrait' : ratio > 1.2 ? 'landscape' : 'square';
    // Missing video metadata still needs a stable stage before its first frame loads.
    if (item?.kind === 'video' && !(item.width && item.height))
      node.dataset.visualAspect = 'portrait';
  });
  if (post.title) {
    const title = ctx.e('span', 'visual-media-title', post.title);
    card.querySelector('.post-identity').append(title);
  }
}

/** A native modal hosts the existing authorized reply workflow without navigating
 * away from the feed. Expanded rendering is reused so reactions and reply drafts
 * keep their established reconciliation behavior; the feed's media is not duplicated. */
export function openVisualComments(ctx, post, renderPost) {
  const latest = ctx.state.posts.find((item) => item.id === post.id) ?? post;
  const body = renderPost(latest, { expanded: true, renderMedia: false });
  const comments = body.querySelector('.comments');
  body.className = 'visual-comments-sheet';
  body.replaceChildren(comments);
  ctx.dialog('Comment', body);
  comments?.querySelector('input')?.focus({ preventScroll: true });
}
